import { memo, useState } from "react";
import { useTranslation } from "react-i18next";

import './index.scss'
import { Link, Path, useLocation } from "react-router-dom";
import Icon from "../Icon";
import { ICON } from "../Icon/data";

type Menu = {
  paths: Path[]
}

const Menu = memo(({ paths }: Menu) => {
  const { t } = useTranslation()
  const location = useLocation()

  const [open, setOpen] = useState<boolean>(false)

  return (
    <div className="Menu">
      <div className="Menu__top">
        <div
          className="Menu__button"
          role="button"
          tabIndex={0}
          onClick={() => setOpen(!open)}
        >
          <Icon icon={open ? ICON.CLOSE : ICON.HAMBURGER} color="#ffffff" />
        </div>
        <div className="Menu__logo">
          <Link to="/">
            <Icon icon={ICON.LOGO} color="#ffffff" size={40} fill="#98281F" />
          </Link>
        </div>
        <div className="Menu__logo-dark">
          <Link to="/">
            <>
              <Icon icon={ICON.LOGO} color="#98281F" size={40} fill="#ffffff" />
            </>
          </Link>
        </div>
      </div>
      <div className={`Menu__options${open ? ' open' : ' closed'}`}>
        <div className="Menu__options-links">
          {paths?.filter((path) => path.inMenu).map((path) => {
            const { label, url, icon, active_icon } = path
            const isActive = location.pathname.includes(url)
            return (
              <div
                className={`Menu__options-item${isActive ? ' active' : ''}`}
                key={url}
              >
                <Link to={url}>
                  <Icon icon={isActive && active_icon ? active_icon : icon} color="#ffffff" size={24} />
                  {label}
                </Link>
              </div>
            )
          })}
        </div>
        <div className="Menu__options-item">
          <Icon icon={ICON.HELP} color="#ffffff" size={24} />
          {t('Help')}
        </div>
      </div>
    </div>
  )
})

export default Menu
